import React from 'react';
import { Navigate } from 'react-router-dom';
import { useResourcePermissions } from '../../../hooks/useResourcePermissions';
import { ResourcePermissions } from '../../../utils/permission-utils';

interface RequireActionProps {
  resourceRoute: string;
  /** Permiso requerido para entrar (p. ej. canCreate en "agregar", canUpdate en "editar"). */
  action: keyof ResourcePermissions;
  redirectTo: string;
  children: React.ReactNode;
}

/** Igual que RequireMenuVisibility pero para pantallas de acción (crear, editar, trasladar…). */
const RequireAction: React.FC<RequireActionProps> = ({ resourceRoute, action, redirectTo, children }) => {
  const permissions = useResourcePermissions(resourceRoute);
  if (permissions.isLoadingPermissions) return null;
  if (!permissions[action]) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
};

export default RequireAction;
